export const activities = {
  title: "Activités quotidiennes",
  subtitle: "Une journée à Gándara",
  items: {
    personal: {
      title: "Travail personnel",
      description: "Temps dédié au développement individuel avec du matériel Montessori, permettant à chaque enfant d'avancer à son propre rythme"
    },
    workshops: {
      title: "Ateliers et projets",
      description: "Activités dirigées qui favorisent la créativité, le travail d'équipe et l'apprentissage pratique"
    },
    tutoring: {
      title: "Tutorat",
      description: "Moments pour le suivi personnalisé des progrès académiques et émotionnels"
    },
    assembly: {
      title: "Assemblée",
      description: "Espace quotidien de conversation où nous partageons, réfléchissons et résolvons les conflits en communauté"
    },
    rest: {
      title: "Repos et alimentation",
      description: "Pauses structurées pour promouvoir des habitudes saines et recharger les énergies"
    },
    play: {
      title: "Jeu libre",
      description: "Temps essentiel pour la socialisation, la créativité et le développement physique dans des environnements naturels"
    }
  }
};
